import { useQuery } from "react-query";
import axios from "infra/http";
import { ContasComposicoesAgrupadasResponse } from "../typings";

function useCobrancaContasComposicoes(
  {
    unidadeId,
    contas,
    dataAtualizacao,
  }: {
    unidadeId: string;
    contas: string[];
    dataAtualizacao?: string;
  },
  body?: {
    taxasModificadas?: Record<
      string,
      Record<
        string,
        { taxaMulta: number; taxaJuros: number; taxaCobranca: number }
      >
    >;
  }
) {
  return useQuery(
    [
      `/v1/cobranca/${unidadeId}/detalhes-contas`,
      contas,
      dataAtualizacao,
      body,
    ],
    async () => {
      const res = await axios.post<ContasComposicoesAgrupadasResponse[]>(
        `/v1/cobranca/${unidadeId}/detalhes-contas`,
        body?.taxasModificadas
          ? {
              contas: Object.keys(body.taxasModificadas!).map((contaId) => ({
                contaId,
                taxasModificadas: Object.keys(
                  body.taxasModificadas![contaId]
                ).map((categoriaFinanceiraId) => ({
                  categoriaFinanceiraId,
                  taxaMulta:
                    body.taxasModificadas![contaId][categoriaFinanceiraId]
                      .taxaMulta,
                  taxaJuros:
                    body.taxasModificadas![contaId][categoriaFinanceiraId]
                      .taxaJuros,
                  taxaCobranca:
                    body.taxasModificadas![contaId][categoriaFinanceiraId]
                      .taxaCobranca,
                })),
              })),
            }
          : null,
        {
          params: { contas, dataAtualizacao },
        }
      );

      return res.data;
    },
    {
      enabled: !!unidadeId,
    }
  );
}

export default useCobrancaContasComposicoes;
